import React from "react";
import { connect } from "react-redux";
import { RewardRedeemContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { portalService } from "apiServices";
import {
  REWARD_RENDER_TYPE,
  REDER_REWARD_USAGE_METHOD,
} from "utils/functions/reward";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import * as XLSX from "xlsx";
import moment from "moment";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import { ROUTE_PATH } from "utils/constants/routePath";
import { Buttons, Displays, Inputs, Modals, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class RewardRedeemContainer extends React.Component {
  state = {
    isLoading: true,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    const query =
      this.props.router.location.search ||
      `?status=2,3&date_type=redeemed_at&limit=${perPage}`;
    this.setState(
      PARSE_LIST_QUERY(this.props.router.location.search, perPage, ["status", "date_type"]),
    );
    this.fetchData(query);
  }

  fetchData = async (queryString) => {
    let resArr = await Promise.all([
      portalService.GET_REWARD_DETAIL(this.props.router.params.id),
      portalService.GET_REWARD_VOUCHER(
        this.props.router.params.id,
        queryString
      ),
      portalService.GET_REWARD_E_VORCHER_STATISTIC_STATUS(
        this.props.router.params.id
      ),
    ]);
    if (resArr) {
      this.setState({
        data: resArr[0].data,
        rewardHistorydata: resArr[1].data,
        rewardEVoucherStatisticStatus: resArr[2].data,
        pagination: {
          last_page: resArr[1].data.totalPages,
          current_page: resArr[1].data.page,
          total: resArr[1].data.totalDocs,
          per_page: resArr[1].data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  fetchRewardVoucherData = async (queryString) => {
    let res = await portalService.GET_REWARD_VOUCHER(
      this.props.router.params.id,
      queryString
    );
    if (res && res.status === 200) {
      this.setState({
        rewardHistorydata: res.data,
        pagination: {
          last_page: res.data.totalPages,
          current_page: res.data.page,
          total: res.data.totalDocs,
          per_page: res.data.limit,
        },
        isLoading: false,
        isBgLoading: false,
        isLoadingTable: false,
      });
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&status=2,3&date_type=redeemed_at&limit=${per_page}&page=${page}`
      : `?status=2,3&date_type=redeemed_at&limit=${per_page}&page=${page}`;
    this.setState({
      isLoadingTable: true,
    });
    this.props.router.navigate(
      `${ROUTE_PATH.REWARD_REDEEM}/${this.props.router.params.id}${joinQuery}`
    );
    this.fetchRewardVoucherData(joinQuery);
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleExport = async () => {
    const { data, filterQuery } = this.state;
    this.setState({ isBgLoading: true });
    let joinQuery = filterQuery
      ? `${filterQuery}&status=2,3&date_type=redeemed_at&pagination=false`
      : `?status=2,3&date_type=redeemed_at&pagination=false`;
    let res = await portalService.GET_REWARD_VOUCHER_PRODUCT(
      this.props.router.params.id,
      joinQuery
    );
    if (res && res.status === 200) {
      const wb = XLSX.utils.book_new();
      const ws_name = "Reward Data";
      const ws_data = res.data?.map((item, index) => [
        index + 1,
        momentTZ(item.redeemed_at)
          .tz("Asia/Bangkok")
          .format("DD/MM/YYYY HH:mm"),
        item?.first_name,
        item?.last_name,
        item?.phone_number || "-",
        REDER_REWARD_USAGE_METHOD(item?.reward_usage_method),
        item?.redeemed || "-",
        item?.time_to_use,
        item?.used || "-",
        ...Array.from({ length: item.time_to_use }).map((e, i) =>
          item.used_list[i]
            ? momentTZ(item.used_list[i])
                .tz("Asia/Bangkok")
                .format("DD/MM/YYYY HH:mm")
            : "-"
        ),
        item.product_detail && item.product_detail.length > 0 ? "Yes" : "No",
        item.product_detail && item.product_detail.length > 0
          ? item.product_detail[0].pd_dep_desc +
            "-" +
            item.product_detail[0].pd_cat02_desc
          : "-",
        item.product_detail && item.product_detail.length > 0
          ? item.product_detail[0].pd_cat03_desc
          : "-",
        item.product_detail && item.product_detail.length > 0 ? "yamaha" : "-",
        item.product_detail && item.product_detail.length > 0
          ? item.product_detail[0].model_code
          : "-",
        item.product_detail && item.product_detail.length > 0
          ? item.product_detail[0].description
          : "-",
        item.product_detail && item.product_detail.length > 0
          ? item.product_detail[0].serial_no
          : "-",

        item.product_detail && item.product_detail.length > 1
          ? item.product_detail[1].pd_dep_desc +
            "-" +
            item.product_detail[1].pd_cat02_desc
          : "-",
        item.product_detail && item.product_detail.length > 1
          ? item.product_detail[1].pd_cat03_desc
          : "-",
        item.product_detail && item.product_detail.length > 1 ? "yamaha" : "-",
        item.product_detail && item.product_detail.length > 1
          ? item.product_detail[1].model_code
          : "-",
        item.product_detail && item.product_detail.length > 1
          ? item.product_detail[1].description
          : "-",
        item.product_detail && item.product_detail.length > 1
          ? item.product_detail[1].serial_no
          : "-",

        item.instrument_detail && item.instrument_detail.length > 0
          ? "Yes"
          : "No",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].instrument_type_th
          : "-",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].product_th
          : "-",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].brand
          : "-",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].model
          : "-",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].series
          : "-",
        item.instrument_detail && item.instrument_detail.length > 0
          ? item.instrument_detail[0].serial_no
          : "-",

        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].instrument_type_th
          : "-",
        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].product_th
          : "-",
        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].brand
          : "-",
        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].model
          : "-",
        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].series
          : "-",
        item.instrument_detail && item.instrument_detail.length > 1
          ? item.instrument_detail[1].serial_no
          : "-",
      ]);

      // Header row
      ws_data.unshift([
        "No",
        "Redeem Date",
        "First name",
        "Last name",
        "Phone",
        "Used By",
        "Redeemed",
        "Time to use",
        "Used",
        ...Array.from({ length: data.time_to_use }).map(
          (e, i) => `Used Date ${i + 1}`
        ),
        "In Warranty",
        "Instrument type",
        "Instrument name",
        "Instrument brand",
        "Instrument model",
        "Instrument series",
        "Instrument serial no",
        "Instrument type",
        "Instrument name",
        "Instrument brand",
        "Instrument model",
        "Instrument series",
        "Instrument serial no",
        "No Warranty",
        "Instrument type",
        "Instrument name",
        "Instrument brand",
        "Instrument model",
        "Instrument series",
        "Instrument serial no",
        "Instrument type",
        "Instrument name",
        "Instrument brand",
        "Instrument model",
        "Instrument series",
        "Instrument serial no",
      ]);

      const ws = XLSX.utils.aoa_to_sheet(ws_data);

      ws["!cols"] = [
        { wch: 5 },
        { wch: 20 },
        { wch: 30 },
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
        { wch: 20 },
      ];
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(
        wb,
        `reward-redeemed-export-${moment().format("YYYYMMDD_HHmmss")}.xlsx`
      );
      this.setState({
        isBgLoading: false,
      });
    } else {
      this.setState({
        isBgLoading: false,
      });
    }
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  render() {
    const { authenRedux, router } = this.props;
    const {
      isLoading,
      isLoadingTable,
      isBgLoading,
      data,
      rewardHistorydata,
      rewardEVoucherStatisticStatus,
      pagination,
      renderModal,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <RewardRedeemContainerStyled>
        <Displays.BGLoading visible={isBgLoading} timeout={12000} />
        {isLoading ? (
          <Displays.Loading theme_standard_loading />
        ) : (
          <>
            <div className="block_section">
              <div className="title">Redeemed and Used list</div>
              <div className="sub_title">ข้อมูลของรางวัล</div>
              <div className="body">
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Reward Code"}
                    value={data.reward_code}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Reward Name"}
                    value={data.name}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Reward Type"}
                    value={REWARD_RENDER_TYPE(data.type)}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"จำนวนทั้งหมด"}
                    value={`${data.total_amount}`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Active (ยอดคงเหลือ)"}
                    value={`${rewardEVoucherStatisticStatus.active}`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Redeemed คงค้างที่ยังไม่ได้ใช้"}
                    value={`${rewardEVoucherStatisticStatus.redeemed}`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Used"}
                    value={`${rewardEVoucherStatisticStatus.used}`}
                  />
                </div>
                <div className="value_item_wrap">
                  <Displays.LabelValue
                    leftWidth="200px"
                    label={"Expired"}
                    value={`${rewardEVoucherStatisticStatus.expired}`}
                  />
                </div>
              </div>
            </div>
            <div className="line" />
            {/* <div className="filter_wrap">
              <Inputs.InputFilter
                theme_standard_input_filter
                dataFilter={[]}
                btnLabel="ค้นหา"
                onQueryFilter={this.handleFilterKeyword}
                onExport={
                  permission &&
                  (permission.is_export || permission.is_export_condition)
                    ? () => this.handleExport(permission)
                    : false
                }
              />
            </div> */}
            <Inputs.InputFilter
              theme_standard_input_filter
              dataFilter={dataFilter(router.location?.search)}
              btnLabel="ค้นหา"
              onQueryFilter={this.handleFilterKeyword}
              onExport={
                permission &&
                (permission.is_export || permission.is_export_condition)
                  ? () => this.handleExport(permission)
                  : false
              }
            />
            {isLoadingTable ? (
              <Displays.Loading theme_standard_loading />
            ) : (
              <div className="body_table">
                <Tables.Standard
                  columns={columns({
                    permission: permission,
                    time_to_use: data?.time_to_use,
                  })}
                  data={rewardHistorydata.docs}
                  showPagination
                  pagination={pagination}
                  handlePageClick={this.handlePageClick}
                  onChangePerPage={this.handlePerPageChange}
                />
              </div>
            )}
            <div className="btn_wrap">
              <div className="w120">
                <Buttons.BgStandard label="Back" onClick={this.handleCancel} />
              </div>
            </div>
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </RewardRedeemContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "first_name",
      length: "311px",
      filter: {
        fieldQuery: "first_name",
        defaultValue: initialValues["first_name"],
        type: "text",
        label: "First name",
        placeholder: "First name",
      },
    },
    {
      accessor: "last_name",
      length: "311px",
      filter: {
        fieldQuery: "last_name",
        defaultValue: initialValues["last_name"],
        type: "text",
        label: "Last name",
        placeholder: "Last name",
      },
    },
    {
      accessor: "phone_number",
      length: "311px",
      filter: {
        fieldQuery: "phone_number",
        defaultValue: initialValues["phone_number"],
        type: "text",
        label: "Phone",
        placeholder: "",
      },
    },
    {
      accessor: "redeemed_at",
      length: "311px",
      filter: {
        fieldQuery: "redeemed_at",
        defaultValue:
          initialValues["start_date"] && initialValues["end_date"]
            ? {
                startDate: new Date(initialValues["start_date"]),
                endDate: new Date(initialValues["end_date"]),
              }
            : false,
        type: "dateRank",
        placeholder: "เลือกวันที่",
      },
    },
  ];
};

const columns = ({ permission, time_to_use }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Redeem Date</div>,
    accessor: "redeemed_at",
    Cell: (props) => (
      <div>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>First name</div>,
    accessor: "first_name",
    Cell: (props) => (
      <div>
        {!props.value
          ? "-"
          : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.value,
            })}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Last name</div>,
    accessor: "last_name",
    Cell: (props) => (
      <div>
        {!props.value
          ? "-"
          : `${RENDER_CHARACTER_REPLACE_BY_PERMISSION({
              ...permission,
              inputString: props.value,
            })}`}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Phone</div>,
    accessor: "phone_number",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Used By</div>,
    accessor: "reward_usage_method",
    Cell: (props) => REDER_REWARD_USAGE_METHOD(props.value),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Redeemed</div>,
    accessor: "redeemed",
    Cell: (props) => <div>Redeemed</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>Time to use</div>,
    accessor: "time_to_use",
    Cell: (props) => <div>{`${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>used</div>,
    accessor: "used",
    Cell: (props) => <div>{`${props.value}`}</div>,
  },
  ...Array.from({ length: time_to_use }).map((e, i) => ({
    Header: <div style={{ textAlign: "left" }}>Used Date {i + 1}</div>,
    accessor: `used_list[${i}]`,
    Cell: (props) =>
      !props.value
        ? "-"
        : momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm"),
  })),
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 1</div>,
  //   accessor: "used_date_1",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 2</div>,
  //   accessor: "used_date_2",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  // {
  //   Header: <div style={{ textAlign: "left" }}>Used Date 3</div>,
  //   accessor: "used_date_3",
  //   Cell: (props) => (
  //     <div>
  //       {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
  //     </div>
  //   ),
  // },
  {
    Header: <div style={{ textAlign: "left" }}>Instrument</div>,
    accessor: "instrument_name",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
  {
    Header: <div style={{ textAlign: "left" }}>S/N</div>,
    accessor: "serial_no",
    Cell: (props) => <div>{!props.value ? "-" : `${props.value}`}</div>,
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(RewardRedeemContainer));
